module.exports = __webpack_public_path__ + "static/media/sp_about_info.9edfa310.jpg";